/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020-2024 (original work) Open Assessment Technologies SA
 *
 */

import { getEndpointUrl } from '@/core/apiRequest/apiRequest';
import config from '@/config';
import baseRequest from 'core/fetchRequest';
import { mfaStore } from '@/stores/mfa.store';

export function cancelMfa() {
    mfaStore.reset();
}

export async function requestMfaCode({ username, password, clientId }) {
    const body = JSON.stringify({
        grant_type: 'password',
        client_id: clientId,
        username: username.trim(),
        password
    });

    const response = await baseRequest(getEndpointUrl('mfaRequestCode', {}, {}, config.baseUrls.authServer), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body
    });

    if ('token' in response && 'recipient' in response) {
        mfaStore.setVerifyToken(response);
    }

    return response;
}

export async function verifyMfaCode(mfaCode) {
    const body = JSON.stringify({
        token: mfaStore.getVerifyToken(),
        mfaCode
    });

    return baseRequest(getEndpointUrl('mfaVerifyCode', {}, {}, config.baseUrls.authServer), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body
    })
        .then(response => {
            mfaStore.reset();

            return response.refreshToken;
        })
        .catch(async requestError => {
            const response = requestError.response.clone();
            const resp = await response.json();
            const code = resp?.error;

            if (code === 'VERIFICATION_CODE_EXPIRED') {
                mfaStore.reset();
            }

            throw requestError;
        });
}
